<template>
  <h1>ErrorThrowerDev</h1>

  <div class="row">
    <button class="btn btn-success" @click="inexistentKey">
      Inexistent key
    </button>
    <button class="btn btn-success" @click="inexistentVar">
      Inexistent var
    </button>
    <button class="btn btn-success" @click="inexistentFunction">
      Inexistent function
    </button>
    <button class="btn btn-success" @click="callingVarAsFunction">
      Calling var as a function
    </button>
    <button class="btn btn-success" @click="callingFunctionAsVar">
      Calling function as var
    </button>
  </div>
</template>

<script>
import DevComponentContainer from '../DevComponent/DevComponentContainer';

export default {
  name: 'ErrorThrowerDev',
  extends: DevComponentContainer,
  data() {
    return {
      collection: {
        foo: 'bar',
      },
    };
  },
  methods: {
    inexistentKey() {
      console.log('inexistentKey - this.collection.oof');
      console.log(this.collection.oof);
    },
    inexistentVar() {
      console.log('inexistentVar - grey');
      console.log(foo);
    },
    inexistentFunction() {
      console.log('inexistentFunction - foo');
      console.log(foo());
    },
    callingVarAsFunction() {
      console.log('callingVarAsFunction');

      const foo = 'foo';

      foo();
    },
    callingFunctionAsVar() {
      console.log('callingVarAsFunction');

      const foo = function () {};

      console.log(`${foo}oof`);
    },
  },
};
</script>
